export default "__VITE_ASSET__BsazVrFN__"